var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C8.27614 0 8.5 0.223858 8.5 0.5V9.29289L11.8131 5.97978C12.0084 5.78452 12.325 5.78452 12.5202 5.97978C12.7155 6.17504 12.7155 6.49162 12.5202 6.68689L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.47978 6.68689C3.28452 6.49162 3.28452 6.17504 3.47978 5.97978C3.67504 5.78452 3.99162 5.78452 4.18689 5.97978L7.5 9.29289V0.5C7.5 0.223858 7.72386 0 8 0ZM0.5 10C0.776142 10 1 10.2239 1 10.5V13.8333C1 14.1428 1.12292 14.4395 1.34171 14.6583C1.5605 14.8771 1.85725 15 2.16667 15H13.8333C14.1428 15 14.4395 14.8771 14.6583 14.6583C14.8771 14.4395 15 14.1428 15 13.8333V10.5C15 10.2239 15.2239 10 15.5 10C15.7761 10 16 10.2239 16 10.5V13.8333C16 14.408 15.7717 14.9591 15.3654 15.3654C14.9591 15.7717 14.408 16 13.8333 16H2.16667C1.59203 16 1.04093 15.7717 0.634602 15.3654C0.228273 14.9591 0 14.408 0 13.8333V10.5C0 10.2239 0.223858 10 0.5 10Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconGray);
export default __webpack_public_path__ + "static/media/downloadIconGray.cc077f1fe3c1702346347044919a1555.svg";
export { ForwardRef as ReactComponent };